import styled from 'styled-components';

export const NotFoundBox = styled.div``;
export const NotFoundBoxInner = styled.div`
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 20px 36px;
    margin-bottom: 59px;

    @media screen and (max-width: 767px){
        padding: 20px;
        border-radius: 15px;
    }

`;
export const NotFoundImage = styled.div`
    margin-bottom: 15px;

    img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
    }
`;
export const NotFoundText = styled.div`
    margin-bottom: 20px;
`;
export const NotFoundTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 20px;
`;

export const NotFoundButton = styled.div`
    button{
        padding: 13px 31px;
    }
`;
export const NotFoundCategoryTitle = styled.div`
margin-bottom: 30px;
`;
export const NotFoundCategoryText = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 36px;
    font-weight: 700;
    line-height: 46px;
`;
